module.exports = __webpack_public_path__ + "img/brand02.9e5292b5.png";